import { createAction } from '@mews/framework';
import { CLEAR_ERROR, LOG_ERROR } from './actionTypes';

export const logErrorMessage = (message: $TSFixMe) => createAction(LOG_ERROR, { message });
export const logErrorKey = (key: $TSFixMe) => createAction(LOG_ERROR, { key });

export const clearError = () => createAction(CLEAR_ERROR);
